import { Button, Modal, Callout } from '@dev-spendesk/grapes';
import React from 'react';

import { PhoneNumberInput } from 'common/components/PhoneNumberInput';
import { useTranslation } from 'common/hooks/useTranslation';

type ModalMFAVerifyPhoneProps = {
  onClose: () => void;
  onVerifyPhone: () => void;
  onPhoneNumberChange: (phone: string) => void;
  phoneNumber: string;
  isPhoneNumberValid: boolean;
  isMobileNumber: boolean;
  isLoading: boolean;
  isOpen: boolean;
  title?: string;
  subtitle?: string;
  showAppCallout?: boolean;
};

export const ModalMFAVerifyPhone = ({
  onClose,
  onVerifyPhone,
  onPhoneNumberChange,
  phoneNumber,
  isPhoneNumberValid,
  isMobileNumber,
  isLoading,
  isOpen,
  title,
  subtitle,
  showAppCallout = true,
}: ModalMFAVerifyPhoneProps) => {
  const { t } = useTranslation('global');

  const getSubtitle = () => {
    if (subtitle) {
      return subtitle;
    }
    return isMobileNumber
      ? t('mfa.modal.phone.desc')
      : t('mfa.modal.phone.descMobile');
  };

  return (
    <Modal
      actions={[
        <Button
          key="cancel"
          onClick={onClose}
          text={t('misc.cancel')}
          variant="secondaryNeutral"
        />,
        <Button
          key="continue"
          text={
            isMobileNumber
              ? t('mfa.modal.phone.buttonAdd')
              : t('mfa.modal.phone.buttonConfirm')
          }
          variant="primaryBrand"
          onClick={onVerifyPhone}
          isDisabled={!isPhoneNumberValid || isLoading}
        />,
      ]}
      iconName="phone"
      iconVariant="info"
      title={title || t('mfa.modal.phone.title')}
      isOpen={isOpen}
      subtitle={getSubtitle()}
    >
      <PhoneNumberInput
        fit="content"
        placeholder="X XX XX XX XX"
        className="ModalMFA__phone-input"
        value={phoneNumber}
        onChange={onPhoneNumberChange}
      />
      {showAppCallout && (
        <Callout
          variant="info"
          title={t('mfa.modal.phone.calloutTitle')}
          className="mt-24"
        >
          {t('mfa.modal.phone.calloutDesc')}
        </Callout>
      )}
    </Modal>
  );
};
